import type { Country } from './Country';
import type { UseCase } from './enums';

interface ExperimentTag {
  num: number;
  id: string;
  variant: string;
}

export type Experiments = ExperimentTag[];

export const featuresKey = {
  newPaymentsView: 'anzApacUiFeature',
  deleteSavedCreditCard: 'deleteSavedCCFeature',
  invoiceSavedCCFeature: 'invoiceSavedCCFeature',
  disablePaymentRedirectForUpgrade: 'disablePaymentRedirectForUpgrade',
  showIDOnlineBanking: 'showIDOnlineBanking',
  showHKFps: 'showHKFps',
  aaTest: 'aaTest',
  aaTestBNPL: 'aaTestBNPL',
  aaTestHidePayInvoice: 'aaTestHidePayInvoice',
  showPaymentRedirectForUpgrade: 'showPaymentRedirectForUpgrade',
  showPaymentRedirectForAdBudget: 'showPaymentRedirectForAdBudget',
  showPHBnpl: 'showPHBnpl',
  showPHPaymaya: 'showPHPaymaya',
  hidePayInvoiceMY: 'hidePayInvoiceMY',
  hidePayInvoiceAU: 'hidePayInvoiceAU',
  hidePayInvoiceNZ: 'hidePayInvoiceNZ',
  hidePayInvoiceID: 'hidePayInvoiceID',
  hidePayInvoiceSG: 'hidePayInvoiceSG',
  hidePayInvoicePH: 'hidePayInvoicePH',
  hidePayInvoiceHK: 'hidePayInvoiceHK',
  hidePayInvoiceTH: 'hidePayInvoiceTH',
  bannerPreHidePayInvoiceHK: 'bannerPreHidePayInvoiceHK',
  bannerPreHidePayInvoiceID: 'bannerPreHidePayInvoiceID',
  bannerPreHidePayInvoiceMY: 'bannerPreHidePayInvoiceMY',
  bannerPreHidePayInvoiceNZ: 'bannerPreHidePayInvoiceNZ',
  bannerPreHidePayInvoicePH: 'bannerPreHidePayInvoicePH',
  bannerPreHidePayInvoiceSG: 'bannerPreHidePayInvoiceSG',
  bannerPreHidePayInvoiceTH: 'bannerPreHidePayInvoiceTH',
  bannerPostHidePayInvoiceHK: 'bannerPostHidePayInvoiceHK',
  bannerPostHidePayInvoiceID: 'bannerPostHidePayInvoiceID',
  bannerPostHidePayInvoiceMY: 'bannerPostHidePayInvoiceMY',
  bannerPostHidePayInvoiceNZ: 'bannerPostHidePayInvoiceNZ',
  bannerPostHidePayInvoicePH: 'bannerPostHidePayInvoicePH',
  bannerPostHidePayInvoiceSG: 'bannerPostHidePayInvoiceSG',
  bannerPostHidePayInvoiceTH: 'bannerPostHidePayInvoiceTH',
  toggleHidePayByInvoice: 'toggle-hide-pay-by-invoice',
  toggleShowSubmitDigitalDocInfo: 'toggle-show-submit-digital-doc-info',
};

export const getExperimentsFromFeatures = (
  features: string[],
  usCase: UseCase,
  country: Country,
  isCajaUpsell?: boolean,
): ExperimentTag[] => {
  // Experiments context data - https://myseek.atlassian.net/wiki/spaces/SAA/pages/2471919748/Stored+Credit+Card+Tracking+PaMI
  const contextData = {
    showPayInvoice: {
      num: 7,
      id: 'payment_widget_remove_invoice',
      variant: '0',
    },
    hidePayInvoice: {
      num: 7,
      id: 'payment_widget_remove_invoice',
      variant: '1',
    },
  };
  const experiment: Experiments = [];

  if (country === 'MY' && usCase === 'CAJA' && !isCajaUpsell) {
    if (features.includes(featuresKey.aaTestHidePayInvoice)) {
      experiment.push(contextData.hidePayInvoice);
    } else {
      experiment.push(contextData.showPayInvoice);
    }
  }

  return experiment;
};
